var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "video-quick-tour",
    { attrs: { height: _vm.videoHeight, "video-name": "Intro3_Journal" } },
    [
      _c("h4", { staticClass: "my-3 my-xl-0 font-outfit-medium" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("pages.pricing.featuresName.businessPlan")) + " "
        ),
      ]),
      _c("div", {
        domProps: { innerHTML: _vm._s(_vm.$t("businessPlanQuickTourText")) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }